import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/icons/arrow-up-right.svg'


const _hoisted_1 = { class: "flex-1 h-full grid place-items-center bg-active transition-[background-color] duration-300 group-hover:bg-brown" }

import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogButton',
  setup(__props) {

const router = useRouter();

const { t } = useI18n();

function goToBlogPage() {
  router.push({ name: ROUTE_NAMES.BLOG_LIST });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "group flex items-center xl:w-[167px] xl:h-[64px] h-[56px] w-[127px] text-white sf-pro-sm",
    onClick: goToBlogPage
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)("pages.home.header.blog")), 1),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "relative xl:w-[64px] w-[56px] h-full grid place-items-center overflow-hidden" }, [
      _createElementVNode("span", { class: "absLayer grad-arrow-normal group-hover:opacity-0" }),
      _createElementVNode("span", { class: "absLayer grad-arrow-hover opacity-0 group-hover:opacity-100" }),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "arrow",
        class: "relative z-10 w-6 h-6 transition-transform duration-300 ease-in-out group-hover:rotate-45"
      })
    ], -1))
  ]))
}
}

})